module.exports = __webpack_public_path__ + "static/media/header_uhren.00545cf0.jpg";